<div class="search btn-{{ size }}">
  @if (searchIcon) {
    <img
      alt="Search"
      class="search-icon"
      height="17"
      width="16"
      ngSrc="./assets/search.svg"
      NgOptimizedImage />
  }
  <input
    #search
    type="text"
    [class.search-spacing]="!searchIcon"
    class="form-control h4-reg search-input btn-{{ size }}"
    placeholder="{{ placeholder }}"
    [disabled]="disabled"
    [ngClass]="{ focus: active === true }"
    [value]="searchString"
    aria-label="Search input" />
  <button
    class="btn btn-primary h4-reg"
    [ngClass]="{ 'search-btn': SearchBtn === true }"
    aria-label="Search button">
    /
  </button>
  <button
    class="btn btn-primary h4-reg d-none"
    [ngClass]="{ 'escape-btn': SearchBtn === true }"
    aria-label="Escape button">
    Esc
  </button>
</div>
<ng-content></ng-content>
